module.exports = __webpack_public_path__ + "static/media/Carosel P 2.95f0b6ea.svg";